function zopimOpen () {
  if (typeof window === 'undefined') return
  if (typeof window.$zopim === 'undefined') return

  window.$zopim.livechat.window.show()
}

module.exports = { zopimOpen }
